import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from '../services/auth.service';
import { LoginRequestDTO } from '../model/auth/login-request-dto';
import { ApiResponse } from '../model/auth/api-response';
import { LoginResponseDTO } from '../model/auth/login-response-dto';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  errorMessage = '';
  hidePassword = true;
  returnUrl = '/admin/workbies';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit(): void {
    // Si ya está autenticado, redirigir
    if (this.authService.isAuthenticated()) {
      this.router.navigate([this.returnUrl]);
      return;
    }

    // Obtener URL de retorno de los query params
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin/workbies';
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const credentials: LoginRequestDTO = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password
    };

    this.authService.login(credentials).subscribe({
      next: (response: ApiResponse<LoginResponseDTO>) => {
        console.log('Respuesta del login:', response);
        
        if (response.statusCode === '000') {
          // Obtener permisos antes de redirigir
          this.authService.getFrontendPermissions().subscribe({
            next: () => {
              this.loading = false;
              this.router.navigate([this.returnUrl]);
            },
            error: (err: any) => {
              console.error('Error obteniendo permisos:', err);
              // Aún así redirigir
              this.loading = false;
              this.router.navigate([this.returnUrl]);
            }
          });
        } else {
          this.loading = false;
          this.errorMessage = response.message || 'Error al iniciar sesión';
          console.log('Login fallido, statusCode:', response.statusCode);
        }
      },
      error: (err: any) => {
        this.loading = false;
        console.error('Error en login:', err);
        
        if (err.status === 401 || err.status === 400) {
          this.errorMessage = 'Email o contraseña incorrectos';
        } else if (err.status === 403) {
          this.errorMessage = 'Usuario desactivado';
        } else {
          this.errorMessage = 'Error de conexión. Intente nuevamente.';
        }
      }
    });
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }
}
